<script setup>
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import apiClient from "@/apiClient.js";
import SupplierForm from "./SupplierForm.vue";

const router = useRouter();
const form = reactive({
  company: "",
  category_id: null,
  vat_number: "",
  website: "",
  address: "",
});
const categories = ref([]);
const saving = ref(false);

const loadCategories = async () => {
  const { data } = await apiClient.get("/api/supplier/categories");
  categories.value = data;
};

const saveSupplier = async () => {
  if (!form.company?.trim()) {
    alert("Company name is required.");
    return;
  }
  saving.value = true;
  try {
    const { data } = await apiClient.post("/api/supplier", form);
    router.push({
      name: "supplier-view",
      params: { id: data.id },
    });
  } catch (error) {
    alert(error?.response?.data?.message ?? "Unable to create supplier.");
  } finally {
    saving.value = false;
  }
};

onMounted(() => {
  loadCategories();
});

const closeModal = () => {
  router.push({ name: "supplier-list" });
};
</script>

<template>
  <div class="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/70 backdrop-blur">
    <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-3xl mx-4">
      <div class="flex items-center justify-between border-b border-slate-200 dark:border-slate-700 px-6 py-4">
        <div>
          <h2 class="text-xl font-semibold">Create Supplier</h2>
          <p class="text-sm text-slate-500 dark:text-slate-300">
            Capture supplier details and keep your records tidy.
          </p>
        </div>
        <button class="btn" @click.prevent="closeModal">
          Close
        </button>
      </div>

      <div class="px-6 py-6 max-h-[80vh] overflow-y-auto">
        <SupplierForm :modelValue="form" :categories="categories"
          @update:modelValue="value => Object.assign(form, value)" />
        <div class="flex justify-end gap-2 mt-8">
          <button class="btn" @click.prevent="closeModal">
            Cancel
          </button>
          <button class="btn accent" @click.prevent="saveSupplier" :disabled="saving">
            {{ saving ? "Saving…" : "Create Supplier" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
